import store from '@/store'

/* eslint-disable global-require */
const AdminDashboard = r => require.ensure([], () => r(require('./dashboard.vue')), 'admin-bundle')
const Calendar = r => require.ensure([], () => r(require('./calendar/calendar.vue')), 'admin-bundle')

const requiresAdmin = (to, from, next) => {
  const auth = store.state.Auth
  if (auth.user && auth.user.isadmin === '1') next()
  else next({ name: 'dashboard.index' })
}

const meta = {
  requiresAuth: true,
}

export default [
  {
    name: 'admin',
    path: '/admin',
    component: AdminDashboard,
    meta,
    beforeEnter: requiresAdmin,
    children: [
      {
        name: 'admin.calendar',
        path: '/admin/calendar',
        component: Calendar,
        meta,
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/app/admin/routes.js